var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 25.3203V17.8203C15 13.8421 16.5804 10.0268 19.3934 7.21371C22.2064 4.40066 26.0218 2.82031 30 2.82031C33.9782 2.82031 37.7936 4.40066 40.6066 7.21371C43.4196 10.0268 45 13.8421 45 17.8203V25.3203H47.5C51.6421 25.3203 55 28.6782 55 32.8203V50.3203C55 54.4624 51.6421 57.8203 47.5 57.8203H12.5C8.35786 57.8203 5 54.4624 5 50.3203V32.8203C5 28.6782 8.35786 25.3203 12.5 25.3203H15ZM22.9289 10.7492C24.8043 8.87388 27.3478 7.82031 30 7.82031C32.6522 7.82031 35.1957 8.87388 37.0711 10.7492C38.9464 12.6246 40 15.1681 40 17.8203V25.3203H20V17.8203C20 15.1681 21.0536 12.6246 22.9289 10.7492ZM12.5 30.3203C11.1193 30.3203 10 31.4396 10 32.8203V50.3203C10 51.701 11.1193 52.8203 12.5 52.8203H47.5C48.8807 52.8203 50 51.701 50 50.3203V32.8203C50 31.4396 48.8807 30.3203 47.5 30.3203H12.5Z",
    fill: "#EB5B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6bee0211b02b7de806db179cc251cce1.svg";
export { ForwardRef as ReactComponent };